const visileColumns = [
  {
    title: "Announcement ID",
    field: "ANNOUNCEMENT_ID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Position Title",
    field: "PositionTitle",
    locked: false,
    filter: "text",
    width: "400",
    show: true,
  },
  {
    title: "Status",
    field: "Status",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "GENERAL AVAILIBILITY ID",
    field: "GENERAL_AVAILIBILITY_ID",
    locked: false,
    filter: "text",
    width: "280",
    show: true,
  },
  {
    title: "GA Elasped Days",
    field: "GenFromCreated",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    className: "text-end",
    // headerClassName: "number-align",
    width: "160",
    show: true,
  },
  {
    title: "CERTIFICATION PID",
    field: "CERTIFICATION_PID",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Recruitment HR-Control",
    field: "Recruitment_HrControl",
    locked: false,
    filter: "text",
    width: "250",
    show: true,
  },
  {
    title: "GA Recruitment HR-Control",
    field: "GARecruitment_HrControls",
    locked: false,
    filter: "text",
    width: "250",
    show: true,
  },
  {
    title: "Assigned ASO",
    field: "Hr_Aso",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Assigned ASO Employee ID",
    field: "Hr_Aso_empid",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    className: "text-end",
    // headerClassName: "number-align",
    width: "260",
    show: true,
  },
  {
    title: "Cert Elasped Days",
    field: "CertFromCreated",
    locked: false,
    filter: "numeric",
    customFilterType: "CustomNumericText",
    className: "text-end",
    // headerClassName: "number-align",
    width: "160",
    show: true,
  },
  {
    title: "DepartmentName",
    field: "DepartmentName",
    locked: false,
    filter: "text",
    width: "400",
    show: true,
  },
  {
    title: "Eligibility IDs",
    field: "ELIGIBILITY_IDs",
    locked: false,
    filter: "text",
    width: "280",
    show: true,
  },
];

export default visileColumns;
